// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"e129a223","200":"c7f6feb3","304":"47189886","448":"df7d6d82","656":"2e939328"}[chunkId] + ".chunk.css";
};